"use client";
import React, { useEffect, useRef, useState } from "react";

import { scrollInContainer } from "@stadium/helpers/animate";

import styles from "./main.module.scss";

const ScrollToTopBtn = ({ containerRef, topOffset = 0, scrollThreshold = 500 }) => {
  const [showButton, setShowButton] = useState(false);
  const windowRef = useRef(globalThis.window);
  const parentRef = containerRef || windowRef;

  const handleVisibleButton = () => {
    const scrollPosition = parentRef.current?.scrollY;

    setShowButton(scrollPosition >= scrollThreshold);
  };

  useEffect(() => {
    parentRef?.current?.addEventListener("scroll", handleVisibleButton);

    return () => parentRef?.current?.addEventListener("scroll", handleVisibleButton);
  }, []);

  const handleClick = () => {
    scrollInContainer({ scrollDistance: topOffset });
  };

  return showButton ? (
    <div>
      <button className={styles.scrollToTopBtn} onClick={handleClick}>
        <span className={styles.iconUp} />
      </button>
    </div>
  ) : (
    ""
  );
};

export default ScrollToTopBtn;
